<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <SectionTitle :title="'Bản đồ chuyên đề'" />
            <FloodMap showReportButton />
        </div>
    </div>
</template>

<script>
import FloodMap from '@/components/FloodMap';
import SectionTitle from '@/components/SectionTitle';
import CONSTANTS from '@/constants';
import { mapActions, mapState } from 'vuex';
export default {
    components: {
        FloodMap,
        SectionTitle
    },
    async mounted() {
        await this.$nextTick();
        this.getListStation();
        this.getWaterReportByMonth();
        this.getRainReportByYear({ type: 'month' });
    },
    data() {
        return {
            CONSTANTS
        };
    },
    computed: {
        ...mapState({})
    },
    methods: {
        ...mapActions({
            getWaterReportByMonth: 'analyze/getWaterReportByMonth',
            getRainReportByYear: 'analyze/getRainReportByYear',
            getListStation: 'station/getList'
        })
    }
};
</script>
<style lang="scss" scoped>
</style>
